import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import AppHeader from "@/components/AppHeader";

// Distinct URL (/request/success) usable later as a Google Ads conversion event.
export default function RequestSuccess() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const isEmergency = state?.emergency;

  return (
    <div className="min-h-screen bg-[#F4F5F7]">
      <AppHeader />
      <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="request-success">
        <CheckCircle2 size={56} className="text-flame mx-auto" />
        <h1 className="font-heading font-black tracking-tighter text-navy text-4xl mt-6">Request submitted</h1>
        <p className="text-slate-500 mt-4">
          {isEmergency
            ? "Your request is marked URGENT / EMERGENCY. Matching professionals are notified immediately."
            : "Matching local professionals will review your request and respond with offers."}
        </p>
        <button data-testid="request-success-dashboard-btn" onClick={() => navigate("/dashboard")}
          className="mt-10 bg-flame hover:bg-flame-dark text-white font-heading font-bold uppercase tracking-wider text-sm px-8 py-4 transition-colors">
          Go to My Dashboard
        </button>
      </div>
    </div>
  );
}
